import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MasterLayout from "../../../masterLayout/MasterLayout";
import axios from "axios";
import { baseUrl } from "../../../helper/urls";
import CustomTable from "../../../components/custom_table/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { Chip } from "@mui/material";

export default function PendingBookingList() {
  const { token } = useSelector((state) => state.auth);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${baseUrl}/bookings/getPendingBookingStudent`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response.data.data);
    } catch (err) {
      console.error("Failed to fetch pending booking list", err);
      setError("Failed to fetch pending bookings. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("reqId", { header: "Request ID", size: 20 }),

    // columnHelper.accessor("studentFirstName", {
    //   header: "Student Name",
    //   size: 40,
    //   Cell: (cell) => {
    //     const { studentFirstName, studentLastName } = cell.row.original || {};
    //     console.log("studentFirstName", studentFirstName, studentLastName);
    //     return (
    //       <div>{(studentFirstName || "") + " " + (studentLastName || "")}</div>
    //     );
    //   },
    // }),

    columnHelper.accessor("counselorFirstName", {
      header: "Counselor Name",
      size: 40,
      Cell: (cell) =>
        cell.row.original?.counselorFirstName +
        " " +
        cell.row.original?.counselorLastName,
    }),
    columnHelper.accessor("counselorinterestedIn", {
      header: "Service Type",
      size: 20,
      Cell: (cell) => cell.row.original?.counselorinterestedIn,
    }),

    columnHelper.accessor("call_time", {
      header: "Call Time",
      size: 30,
      Cell: (cell) => cell.row.original?.call_time || "N/A",
    }),

    columnHelper.accessor("approved_slots", {
      header: "Total Slots",
      size: 20,
      Cell: (cell) => cell.row.original?.approved_slots,
    }),
    columnHelper.accessor("Scheduled", {
      header: "Scheduled Slots",
      size: 20,
      Cell: (cell) => cell.row.original?.Scheduled,
    }),
    columnHelper.accessor("Unscheduled", {
      header: "Unscheduled Slots",
      size: 20,
      Cell: (cell) => cell.row.original?.Unscheduled,
    }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 20,
      Cell: (cell) => {
        const status = cell.row.original?.status;
        if (status === 0)
          return <Chip label="Pending" color="error" variant="outlined" />;
        if (status === 1)
          return <Chip label="Unpaid" color="success" variant="outlined" />;

        if (status === 2) return <Chip label="Paid" color="success" />;
        if (status === 3) return <Chip label="Completed" color="primary" />;
        return "";
      },
    }),
    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 20,
    //   Cell: (cell) => cell.row.original?.created_at?.split("T")[0],
    // }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   size: 20,
    //   Cell: (cell) => {
    //     const status = cell.row.original?.status;
    //     if (status === 0)
    //       return <Chip label="Pending" color="error" variant="outlined" />;
    //     if (status === 1)
    //       return <Chip label="Unpaid" color="success" variant="outlined" />;

    //     if (status === 2) return <Chip label="Paid" color="success" />;
    //     if (status === 3) return <Chip label="Completed" color="primary" />;
    //     return "Unknown";
    //   },
    // }),
  ];

  return (
    <MasterLayout>
      {loading ? (
        <p>Loading pending bookings...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <>
          <CustomTable columns={columns} data={data} loading={loading} />
        </>
      )}
    </MasterLayout>
  );
}
